<template>
  <!-- 获奖库 -->
  <div class="section home-award">
    <home-title title="获奖库" clickTitle @toList="toBaseList">
      <div slot="cate" class="cate" v-if="cateList">
        <span
          :class="{'active': cateIndex == index}"
          v-for="(item, index) in cateList"
          :key="index"
          @click="changeCate(item,index)"
        >{{item.name}}</span>
      </div>
    </home-title>
    <div class="container flex start" v-if="cateList">
      <div class="title" @click="toBaseList">
      </div>
      <div class="award-list flex-bd" v-if="cateList && cateList[cateIndex]" :class="{'wx': cateList[cateIndex].name=='文学'}">
        <template  v-if="cateList[cateIndex].name!='文学'">
          <template v-for="(item,index) in cateList[cateIndex].dataList">
            <AwardItem :item="item" :showpath="showpath" :key="index" :path="item.path" />
          </template>
        </template>
        <template v-else>
          <card-table :list="cateList[cateIndex].dataList" showMulType newWindow></card-table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import CardTable from "@/pages/literature/components/CardTable.vue";
import AwardItem from "../listModel/awardItem.vue";
import homeTitle from "./home-title.vue";
import colums from '../../colums/colums';
import { mapState,mapGetters} from "vuex";
import state from '../../store/state';
export default {
  name: "hjk",
  props: {
    msg: String
  },
  components: {
    AwardItem,
    homeTitle,
    CardTable
  },
  data() {
    return {
      cateList:null,
      cateIndex: 0,
      showpath: "",
      list: null
    };
  },
  computed:{
    ...mapGetters({cateOrigin:"getAwardCate"})
  },  
  mounted() {
    this.initPage();
    this.getAllWxCate()
  },
  methods: {
    initPage(){
      this.cateList = this.cateOrigin.map(t=>{
        return{
          ...t,
          dataList:[]
        }
      })
      this.getAwardList()
    },
    
    async getAwardList() {
      let params = {
        page: 1,
        pageSize: 6,
        is_award: 1,
        recommend: 1
      };
      let res = await this.$api.jmkApi.getList(params)
      this.showpath = res.showpath;
      let list = res.data || []
      list = await Promise.all(
        list.map(async (v) => {
          return {
            ...v,
            cover_img: this.setImage(res.showpath, v.cover_img, `?x-oss-process=image/resize,m_fill,w_540,h_320`),
            thumbs: v.cover_img ? res.showpath + v.cover_img : ''
          };
        })
      );
      this.cateList.map(t=>{
        if(t.name=='节目'){
          t.dataList = list
        }
      })      
    },
    async getExhibitList(){
      let params = {
          page: 1,
          pageSize: 6,
          is_award: 1,
          is_check: -1,
          is_top: -1,
          recommend: 1,
          category: -1
        };
      let res = await this.$api.exhibitApi.getList(params)
      this.showpath = res.showpath
      let list = res.data
      list = await Promise.all(
        list.map(async (v) => {
          return {
            ...v,
            cover_img: this.setImage(res.showpath, v.cover_img, `?x-oss-process=image/resize,m_fill,w_540,h_320`),
            thumbs: v.cover_img ? res.showpath + v.cover_img : ''
          };
        })
      );
      let curCateObj = this.cateList.find(t=>{return t.name =='展品'})
      list.map(t=>{
        t.name = t.title
        let obj = curCateObj.list.find(v=>{ return v.id == t.category})
        if(obj){
          t.path = obj.path
          if(!t.type_name) t.type_name = obj.name
        }
      })
      this.cateList.map(t=>{
        if(t.name=='展品'){
          t.dataList = list
        }
      })  
    },

    async getAllWxCate(){
      let allRequest = []
      let wxCate = this.cateList.find(t=>{return t.name == '文学'})
      wxCate.list.map(t=>{
        if(t.labelid>0){
          allRequest.push(this.$api.channelApi.getChannel({parentId: t.labelid}))
        }
      })
      let res = await Promise.all(allRequest)
      let list = []
      res.map(t=>{list = list.concat(t.data)})
      this.subWxCate = list
    },

    async getXwList(){
      let params = {
        page: 1,
        pageSize: 9,
        category: -1, //节目分类id,2,4,6,8,10
        is_award: 1, //是否获奖 1，-1
      };
      const res = await this.$api.literatureApi.getList(params)
      const list = res.data || []
      let curCateObj = this.cateList.find(t=>{return t.name =='文学'})
      list.map(t=>{
      if(t.type_id && !t.type_name){
        let obj = this.subWxCate.find(v=>{return v.id == t.type_id})
        obj &&( t.type_name =  obj.name)
      }
      if(t.category){
        let obj = curCateObj.list.find(v=>{return t.category == v.id})
        if (obj) {
          t.category_name = obj.name
          t.path = obj.path
        }
      }
     })
     this.cateList.map(t=>{
        if(t.name=='文学'){
          t.dataList = list.map(v => {
            return {
              ...v,
              author: this.$utils.fixedAuthor(v.listasv),
              recommend: false
            }
          })
        }
      }) 
    },
    toBaseList() {
      this.$router.push('/award')
    },
    toMore() {
      this.$router.push({
        path:"/award",
        query:{
          cate:this.cateList[this.cateIndex].name
        }
      });
    },

    changeCate(item, index) {
      if (this.cateIndex == index) return;
      this.cateIndex = index;
      if(item.dataList && item.dataList.length >0) return
      switch(item.name){
        case '节目':this.getAwardList();break;
        case "展品":this.getExhibitList();break;
        case '文学':this.getXwList();break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
// .home-award .container{
//   gap: 40px;
// }
  .award-list.wx{
    flex: 1;
    background: #fff;
    box-sizing: border-box;
    padding:0 20px 0 30px;
  }
</style>